// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"809":"72131cbee0ffe503","3877":"fe336940f98fdfab","5513":"8f8044ac522ea342","6272":"aa4472f7082b94cd","6341":"2de26825c8577b83"}[chunkId] + ".css";
};